import { render, staticRenderFns } from "./Status404.vue?vue&type=template&id=ee15dffe&scoped=true&"
import script from "./Status404.vue?vue&type=script&lang=js&"
export * from "./Status404.vue?vue&type=script&lang=js&"
import style0 from "./Status404.vue?vue&type=style&index=0&id=ee15dffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee15dffe",
  null
  
)

export default component.exports